import { setNewsLetterSubscription } from "action/utils/setNewsLetterSubscription";
import { subscribeKlaviyoList } from "analytics/klaviyo";
import KlaviyoTrackingService from "analytics/klaviyo/klaviyoEvents";
import onSubmitSubscriptionEmailModalApi from "api/contact/onSubmitSubscriptionEmailModalApi";
import PAButton, { BUTTON_SIZE } from "component/design-system/buttons/PAButton";
import Form from "component/design-system/form/Form";
import Input from "component/design-system/form/Input";
import Text from "component/design-system/typography/Text";
import { isFormEnabled, Validation } from "component/formsy-components/formsy-helper";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { toLowerCase } from "../../util/lodash/toLowerCase";
import styles from "./newsLetterForm.module.scss";

function NewsLetterForm() {
  const [canSubmit, setCanSubmit] = useState(false);
  const [newsLetterSubscribed, setNewsLetterSubscribed] = useState(false);
  const formRef = useRef(null);
  const utils = useSelector((state: RootState) => state.utils);
  const dispatch = useDispatch();
  const router = useRouter();

  const submit = (model) => {
    const { email } = model;
    onSubmitSubscriptionEmailModalApi(toLowerCase(email))
      .then((response: any) => {
        if (response && response.data) {
          setNewsLetterSubscribed(true);
          subscribeKlaviyoList(email, "Article-Landing", router.locale);
          KlaviyoTrackingService.identifyKlaviyoUser(email);
        }
      });
  };

  function hideForm() {
    dispatch(setNewsLetterSubscription(false));
  }

  useEffect(() => {
    if (newsLetterSubscribed) {
      router.events.on("routeChangeComplete", hideForm);
    }
    return () => {
      router.events.off("routeChangeComplete", hideForm);
    };
  }, [newsLetterSubscribed]);

  const enableSubmitButton = () => {
    setCanSubmit(true);
  };

  const disableSubmitButton = () => {
    setCanSubmit(false);
  };

  const handleOnFormChange = () => {
    const formValidations: Validation[] = [{ validationType: "IS_EMAIL", elementName: "email" }];
    const canSubmitForm = isFormEnabled(formRef, ["email"], formValidations);
    setCanSubmit(canSubmitForm);
  };

  if (!utils.isNewsLetterSubscriptionNeeded) {
    return null;
  }

  let renderText = null;
  if (newsLetterSubscribed) {
    renderText = (
      <>
        <Text size="3" bold> Thank you  </Text>
        <Text size="6">Your subscription has been confirmed. You've been added to your list and will hear for us soon.</Text>
      </>
    );
  } else {
    renderText = (
      <>
        <Text size="3" bold> Subscribe To Our Newsletters </Text>
        <Text size="6">Join our subscriber list, to get latest news, updates and special offers delivered direct in your mailbox</Text>
      </>
    );
  }
  return (
    <div className={styles.news_letter}>
      <div className={styles.news_letter_content}>
        {/* <i className="fa fa-envelope-open" /> */}
        <i className={`fa fa-envelope ${styles.envelope}`} />
        {/* <img alt="chat" src="envelope-open-text-solid.svg" /> */}
        {renderText}
        <div>
          <HideIf show={!newsLetterSubscribed}>
            <Form
              id="login-form"
              layout="vertical"
              onValidSubmit={(model: any) => submit(model)}
              onValid={enableSubmitButton}
              onInvalid={disableSubmitButton}
              className={styles.input_container}
              onChange={handleOnFormChange}
              ref={formRef}
              fields={["email"]}
            >
              <Input
                required
                id="email"
                name="email"
                type="email"
                placeholder="Enter Email*"
                validations={{
                  validationType: "IS_EMAIL",
                }}
              />
              <PAButton
                className="btn btn-success btn-block"
                size={BUTTON_SIZE.LARGE}
                type="submit"
                disabled={!canSubmit}
              >
                Subscribe
              </PAButton>
            </Form>
          </HideIf>

        </div>
      </div>
    </div>
  );
}

export default NewsLetterForm;
